module.exports = __webpack_public_path__ + "static/media/icon-virtual.33f6b55c.svg";